import { Auth } from '@nackle/bridge';
import { idURL } from 'endpoints';

const auth = new Auth( {
    authority: idURL
} );

export default auth;

export function hasPermission( permission ) {
    if ( !permission ) {
        return true;
    }
    const [
        app,
        key
    ] = permission.split( '.', 2 );

    const userPermissions = auth?.state?.claims?.permissions;

    if ( !userPermissions ) {
        return false;
    }

    const appPermissions = userPermissions[ app ];

    // hard code permissions for testing
    // const appPermissions = [
    //     'read-recipient',
    //     'edit-recipient',
    //     'delete-recipient',
    //     'list-recipients',
    // ];

    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }

    return appPermissions.includes( key );
}

export const PERMISSIONS = {
    //RECIPIENTS
    READ_RECIPIENT: 'service-awards-api.read-recipient',
    EDIT_RECIPIENT: 'service-awards-api.edit-recipient',
    DELETE_RECIPIENT: 'service-awards-api.delete-recipient',
    LIST_RECIPIENTS: 'service-awards-api.list-recipients',
};